import request from "@/utils/request";

export function login(username, password) {
  return request({
    url: "/mall-admin/admin/login",
    method: "post",
    data: {
      username,
      password,
    },
  });
}

export function getInfo() {
  return request({
    url: "/mall-admin/admin/info",
    method: "get",
  });
}
// 获取IM sign 接口
export function getSign(id) {
  return request({
    url: `/mall-admin/tencentIm/getUserSig/${id}`,
    method: "get",
  });
}

export function logout() {
  return request({
    url: "/mall-admin/admin/logout",
    method: "post",
  });
}

export function fetchAdminList(params) {
  return request({
    url: "/mall-admin/admin/list",
    method: "get",
    params: params,
  });
}
//修改密码
export function updateAdminPassword(data) {
  return request({
    url: "/mall-admin/admin/updatePassword",
    method: "post",
    data,
  });
}
//查询用户列表
export function fetchListAll(params) {
  return request({
    url: "/mall-admin/member/list",
    method: "get",
    params: params,
  });
}
//用户详情列表
export function fetchMemberDetail(id) {
  return request({
    url: "/mall-admin/member/info/" + id,
    method: "get",
    params: params,
  });
}

//修改密码
export function updatePassword(data) {
  return request({
    url: "/mall-admin/member/updatePassword/" + data.id,
    method: "post",
    data: {
      id: data.id,
      phone: data.phone,
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    },
  });
}

export function updateStatus(id, params) {
  return request({
    url: "/mall-admin/member/updateStatus/" + id,
    method: "post",
    params: params,
  });
}

export function getRoleByAdmin(adminId) {
  return request({
    url: `/mall-admin/admin/role/${adminId}`,
    method: "get",
  });
}

export function allocRole(data) {
  return request({
    url: "/mall-admin/admin/role/update",
    method: "post",
    data: data,
  });
}
export function createAdmin(data) {
  return request({
    url: "/mall-admin/admin/register",
    method: "post",
    data: data,
  });
}

export function userupdatepassword(data) {
  return request({
    url: "/mall-admin/merchant/userupdatepassword",
    method: "post",
    data: data,
  });
}
// 重置商户密码
export function resetPassword(data) {
  return request({
    url: "/mall-admin/merchant/resetPassword",
    method: "post",
    data,
  });
}
export function getCaptchaImgApi() {
  return request({
    url: `/mall-admin/captcha/captchaimg`,
    method: "get",
  });
}
export function sendSmsCodeByCaptcha(data) {
  return request({
    url: "/mall-admin/auth/getText",
    method: "post",
    data,
  });
}
